export default "__VITE_ASSET__CaRLU6h2__"